import { render, staticRenderFns } from "./LaboratoryProcedure.vue?vue&type=template&id=5193b9d2&scoped=true"
import script from "./LaboratoryProcedure.vue?vue&type=script&lang=js"
export * from "./LaboratoryProcedure.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryProcedure.vue?vue&type=style&index=0&id=5193b9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5193b9d2",
  null
  
)

export default component.exports